<template>
  <div class="warp">
    <div class="warp1">
      <div class="top"></div>
      <div class="top_china" style="background:#fff;">
        <div class="top_china_cent">
          <div class="top_china_img">
            <img src="../../assets/img/top_logo.png" alt />
            <p>
              <span style="color:#999999FF;font-size:16px;">/</span> 个人中心
            </p>
          </div>
          <div class="top_china-sc">
            <p>基于商会的一站式企业服务平台</p>
            <p>|</p>
            <div class="top_china_bot">
              <img src="../../assets/img/top_slogan.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="conent">
      <div class="conetn_1">
        <div class="conetn_left">
          <div class="conetn_left_1">
            <p>个人中心</p>
          </div>
          <ol class="conetn_left_2">
            <router-link :to="{name:'dingdang',query:{token:this.$route.query.token}}" tag="li">
              <img src="../../assets/img/geren/nav_btn_order_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_order_sel.png" alt=""> -->
              <p>
                <a href="#">我的订单</a>
              </p>
            </router-link>
            <li @click="dialogVisible3 = true">
              <img src="../../assets/img/geren/nav_btn_invoice_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_invoice_sel.png" alt=""> -->
              <p @click="dialogVisible = true">
                <a href="#">我的发票</a>
              </p>
            </li>
            <router-link :to="{path:'/zhinang'}" tag="li">
              <img src="../../assets/img/geren/nav_btn_znt_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_invoice_sel.png" alt=""> -->
              <p>
                <a href="#">我的智囊团</a>
              </p>
            </router-link>
            <router-link :to="{path:'/tiwen'}" tag="li">
              <img src="../../assets/img/geren/nav_btn_ask_nor.png" alt />
              <!-- <img src="../../assets/img/geren/nav_btn_invoice_sel.png" alt=""> -->
              <p>
                <a href="#">我的提问</a>
              </p>
            </router-link>
          </ol>
        </div>
        <div class="content_right">
          <div class="content_right_1">
            <div class="content_right_left">
              <img src="../../assets/img/geren/personal_bg.png" alt />
              <div class="content_right_left_1">
                <div class="content_right_left_img">
                  <img :src="this.photo" alt />
                </div>
                <div class="content_right_left_p">
                  <p class="p1">
                    <span>{{name}}</span>
                    <img src="../../assets/img/geren/sign_icon_boss.png" alt v-if="getokens.is_boss == '1'" />
                    <img src="../../assets/img/geren/sign_icon_fws.png" alt v-if="getokens.is_service == '1'" />
                    <img src="../../assets/img/geren/sign_icon_vip.png" alt v-if="getokens.identity == '1'" />
                  </p>
                  <p class="p2">{{getoken.business_position}}</p>
                  <p class="p2">{{getoken.enterprise_name}}</p>
                  <p class="p3" @click="dialogVisible3 = true">
                    <a href="#">修改资料</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="content_right_right">
              <img src="../../assets/img/geren/personal_banner_QR.png" alt />
            </div>
          </div>
          <div class="content_right_2">
            <div class="content_right_dd">
              <p>我的订单</p>
              <p>
                <span @click="quanbu()">
                  <a href="#">查看全部</a>
                </span>
                <img src="../../assets/img/geren/personal_btn_more.png" alt />
              </p>
            </div>
            <ul class="content_right_ul">
              <li v-for="(item,index) in lists" :key="index" v-if="index < 5">
                <div class="content_right_li1">
                  <div class="imgg">
                    <img :src="item.avatar" alt />
                  </div>
                  <p class="pp1">{{item.service_name}}</p>
                  <p class="pp2">{{item.providers_name}}</p>
                  <p style="width:121px;">{{item.str_status}}</p>
                  <p @click="quanbu(item.id,item.order_status)">
                    <a href="#" style="color:#666">查看订单</a>
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="content_right_2">
            <div class="content_right_dd">
              <p>我的智囊团</p>
              <p>
                <router-link
                  :to="{name:'zhinang',query:{token:this.$route.query.token}}"
                  tag="span"
                >
                  <a href="#">查看全部</a>
                </router-link>
                <img src="../../assets/img/geren/personal_btn_more.png" alt />
              </p>
            </div>
            <div class="content_right_botton">
              <ul>
                <li v-for="(item,index) in list" :key="index">
                  <div class="bottom_li">
                    <div class="bottom_img">
                      <img :src="item.avatar" alt />
                    </div>
                    <div class="bottom_p">
                      <p class="bottom_p1">
                        <span>{{item.providers_name}}</span>
                        <span
                          class="spn"
                          v-if="item.order_num != null"
                          @click="order(item.provider_id)"
                        >
                          <a href="#">合作过{{item.order_num}}笔订单</a>
                        </span>
                      </p>
                      <p style="font-size:14px;">地址：{{item.address}}</p>
                      <p style="font-size:14px;">电话：15644875486</p>
                      <p style="font-size:12px;color:#999999;">{{item.content}}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li>
            <a href="#">关于商企服</a>
          </li>
          <li>
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible3" width="50%">
      <div class="dialog">
        <img src="../../assets/img/geren/pop_QR.png" alt />
        <p>请前往小程序进行操作</p>
      </div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import { orderList, joinProviderList, getRegionList,getToken } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      numm: 0,
      lists: [],
      list: [],
      dialogVisible3: false,
      dialogVisible: false,
      dialogVisible1: false,
      num: 0,
      TIME_COUNT: 60, //验证码倒计时60s
      form: {
        phone: "",
        ecord: ""
      },
      formLogon: {
        phone: "",
        ecord: "",
        name: "",
        enterprise_name: "",
        office_address_province_id: "",
        detailed_address: ""
      },
      count: "",
      show: true,
      cang: false,
      num1: 2,
      options: [],
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      },
      getoken:[],
      getokens:[]
    };
  },
  methods: {
    //划过
    munn() {
      this.num1 = 1;
    },
    munn1() {
      this.num1 = 2;
    },
    // 跳转
    leimu() {
      this.$router.push({ name: "home" });
    },
    table(index) {
      this.numm = index;
    },
    orderlist(token) {
      this.token = localStorage.getItem("token");
      orderList({ token: this.token, page: 1 }).then(res => {
        this.lists = res.data.data.list;
        console.log(this.lists);
      });
    },
    joinProviderlist(token) {
      this.token = localStorage.getItem("token");
      joinProviderList({ token: this.token }).then(res => {
        this.list = res.data.data.list;
        console.log(this.list);
      });
    },
    order(provider_id) {
      this.$router.push({
        name: "zhinangliebiao",
        query: { id: provider_id }
      });
    },
    //登录
    getCode(form) {
      if (!/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.form.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    login() {
      if (this.form.ecord == "") {
        this.$message({
          message: "请输入验证码"
        });
      } else {
        getLogin({
          phone: this.form.phone,
          ecord: this.form.ecord
        }).then(res => {
          console.log(res);
          this.login_login = res.data;
          console.log(this.login_login);
          if (res.data.errcode === 200) {
            this.dialogVisible = false;
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push({
              name: "home",
              query: {
                id: res.data.data.name,
                idimg: res.data.data.photo,
                token: res.data.data.token
              }
            });
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("phone", res.data.data.phone);
            localStorage.setItem("photo", res.data.data.photo);
            localStorage.setItem("member_id", res.data.data.member_id);
          } else if (res.data.errcode == 406) {
            this.$message({
              message: "账号信息不存在，请先注册"
            });
          }
        });
      }
    },
    //注册并登录
    getCode1(formLogon) {
      if (!/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.formLogon.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getlogon() {
      getLogon({
        name: this.formLogon.name,
        phone: this.formLogon.phone,
        ecord: this.formLogon.ecord,
        enterprise_name: this.formLogon.enterprise_name,
        office_address_province_id: this.formLogon.office_address_province_id,
        detailed_address: this.formLogon.detailed_address
      }).then(res => {
        this.logon_logon = res.data.errcode;
        if (res.data.errcode == 200) {
          this.$router.push({
            name: "home",
            query: {
              id: this.formLogon.name
            }
          });
          localStorage.setItem("name", this.formLogon.name);
        }
      });
    },
    handleChange(value) {
      console.log(value);
      let labels = this.$refs["cascaderAddr"].currentLables;
      console.log(this.$refs["cascaderAddr"]);
    },
    getRegion() {
      getRegionList({}).then(res => {
        console.log(res);
        this.options = res.data.data;
      });
    },
    dingdang(id, order_status) {
      if (order_status == "1") {
        this.$router.push({
          name: "dingdan",
          query: {
            id: id
          }
        });
      }
      if (order_status == "2") {
        this.$router.push({
          name: "yuwuzhong",
          query: {
            id: id
          }
        });
      }
      if (order_status == "3") {
        this.$router.push({
          name: "wangjie",
          query: {
            id: id
          }
        });
      }
      if (order_status == "4") {
        this.$router.push({
          name: "wangjie",
          query: {
            id: id
          }
        });
      }
    },
    quanbu() {
      this.$router.push({
        name: "dingdang"
      });
    },
    gettoken(){
        this.id = localStorage.getItem("token");
      getToken({
        token:this.id
      }).then(res =>{
        this.getoken = res.data.data.member_info;
        this.getokens = res.data.data;
      })
    }
  },
  created() {
    this.orderlist();
    this.joinProviderlist();
    this.name = localStorage.getItem("name");
    this.photo = localStorage.getItem("photo");
    this.getRegion(); //城市
    this.$emit("header", true); //是否显示头部
    this.gettoken()
  }
};
</script>

<style scoped>
.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
  margin-top: 40px;
}

.top_china-sc {
  float: right;
}

.top_china-sc p {
  float: left;
  line-height: 100px;
  padding: 0 10px;
  font-size: 14px;
  color: #b2b2b2;
}
.dialog {
  width: 28%;
  height: auto;
  margin: 0 auto;
  text-align: center;
}

.dialog p {
  text-align: center;
  margin: 20px 0;
  font-size: 18px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  height: 42px;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222ff;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.top_ul {
  width: 550px;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.top_china {
  width: 100%;
  overflow: hidden;
}

.top_china_cent {
  width: 1200px;
  margin: 0 auto;
}

.top_china_img img {
  padding: 19px 0;
  float: left;
}

.top_china_scout {
  width: 448px;
  height: 44px;
  background: #007bff;
  float: left;
  margin: 19px 0;
  border-radius: 5px;
  margin-right: 11px;
}

.top_china_img p {
  float: left;
  line-height: 82px;
  font-size: 24px;
  font-weight: bold;
  color: #666666ff;
  margin-left: 15px;
}

.input {
  width: 348px;
  height: 38px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  outline: none;
  border: 0;
  margin: 3px 0 0 3px;
  font-size: 16px;
  float: left;
}

.btn {
  width: 97px;
  height: 44px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  outline: none;
  border: 0;
  background: #007bff;
  font-size: 16px;
  color: #fff;
}
.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
}

.butoon {
  width: 150px;
  height: 44px;
  margin: 19px 0;
  background: #f7681e;
  outline: 0;
  border: 0;
  font-size: 16px;
}

.top_china-sc {
  float: right;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.conent {
  width: 100%;
  height: auto;
  background: #f4f5f9ff;
  overflow: hidden;
}

.conetn_1 {
  width: 1200px;
  height: 1800px;
  /* background: #fff; */
  margin: 0 auto;
  margin-top: 30px;
}

.conetn_left {
  width: 240px;
  height: 284px;
  background: #fff;
  float: left;
}

.conetn_left_1 {
  width: 100%;
  height: 57px;
  border-bottom: 1px solid #e4e4e4ff;
}

.conetn_left_1 p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  padding: 18px 0 0 30px;
}

.conetn_left_2 {
  margin-top: 20px;
}

.conetn_left_2 li {
  width: 240px;
  height: 44px;
}

.conetn_left_2 img {
  float: left;
  padding: 14px 5px 0 29px;
}

.conetn_left_2 p a {
  float: left;
  line-height: 44px;
  font-size: 14px;
  color: #222222ff;
}

.content_right {
  width: 940px;
  height: auto;
  float: right;
}

.content_right_1 {
  width: 100%;
  height: 168px;
}

.content_right_left {
  width: 554px;
  height: 168px;
  float: left;
  position: relative;
}

.content_right_right {
  float: right;
}

.content_right_left_1 {
  width: 494px;
  height: 100px;
  position: absolute;
  top: 40px;
  left: 50%;
  margin-left: -247px;
}

.content_right_left_img {
  float: left;
  padding: 0 22px 0 0;
}

.content_right_left_img img {
  width: 88px;
  height: 88px;
  border-radius: 50px;
}

.content_right_left_p {
  width: 380px;
  float: left;
}

.p1 {
  width: 284px;
  height: 30px;
}

.p1 span {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  float: left;
}

.p1 img {
  float: left;
  padding: 2px 5px;
}

.p2 {
  font-size: 14px;
  color: #fff;
  line-height: 25px;
}

.p3 {
  width: 100px;
  height: 30px;
  background: #f4f5f9;
  opacity: 0.55;
  border-radius: 25px;
  float: right;
  margin-top: -15px;
  text-align: center;
}

.p3 a {
  color: #28b1ffff;
  font-size: 14px;
  line-height: 30px;
}

.p3:hover {
  background: #212140;
}

.content_right_2 {
  width: 100%;
  height: 489 px;
  background: #fff;
  margin-top: 20px;
  overflow: hidden;
}

.content_right_dd {
  width: 100%;
  height: 58px;
  border-bottom: 1px solid #e4e4e4;
}

.content_right_dd p:first-child {
  float: left;
  color: #222222;
  font-weight: 600;
  line-height: 58px;
  padding: 0 30px;
}

.content_right_dd p:last-child {
  float: right;
  line-height: 58px;
  padding: 0 28px;
}

.content_right_dd p:last-child a {
  color: #666666;
}

.content_right_dd p:last-child img {
  float: left;
  padding: 17px 3px;
}

.content_right_dd p:last-child span {
  float: left;
  color: #666666;
}

.content_right_ul {
  width: 100%;
}

.content_right_ul li {
  width: 100%;
  height: 70px;
  border-bottom: 1px solid #e4e4e4;
}

.content_right_li1 {
  width: 880px;
  height: 60px;
  margin: 15px auto;
}

.imgg {
  width: 60px;
  height: 60px;
  float: left;
}

.imgg img {
  width: 60px;
  height: 60px;
}

.content_right_li1 p {
  float: left;
  line-height: 60px;
  font-size: 14px;
  color: #666666;
  padding: 0 0 0 44px;
}

.pp1 {
  width: 234px;
  height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.pp2 {
  width: 200px;
  height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}

.content_right_li1 p:last-child {
  color: #000;
  font-weight: 400;
}

.content_right_botton {
  width: 100%;
  height: 876px;
}

.content_right_botton ul li {
  width: 100%;
  height: 174px;
  border-bottom: 1px solid #e4e4e4;
  overflow: hidden;
}

.bottom_li {
  width: 880px;
  height: 134px;
  margin: 20px auto;
  overflow: hidden;
}

.bottom_img {
  width: 80px;
  height: 134px;
  margin: 0 20px 0 0;
  float: left;
}

.bottom_img img {
  width: 80px;
  height: 80px;
}

.bottom_li p {
  line-height: 23px;
}

.bottom_p1 {
  margin: 0 0 0 0;
}

.bottom_p1 span:first-child {
  font-size: 20px;
}

.spn {
  width: 132px;
  height: 30px;
  background: #f4f5f9;
  border: 1px solid #e4e4e4;
  float: right;
  text-align: center;
}

.bottom_p1 span:last-child a {
  color: #007bff;
  font-size: 12px;
  text-align: center;
  line-height: 30px;
}

/* denglu */
.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  float: left;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro1 {
  width: 322px;
  height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  position: relative;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}
.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  margin-bottom: 20px;
}

.login2_1_one {
  width: 322px;
  height: 550px;
  margin: 20px auto;
}

.login_three {
  width: 100%;
  height: 20px;
  margin-bottom: 20px;
}

.login_three img {
  float: left;
  padding: 0 5px 0 0;
}

.login_three p {
  float: left;
  line-height: 15px;
}

.top_ul li a {
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/view/Geren/Geren.vue